// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import BudgetApp from "./budget-app/BudgetApp"; // Correct import
import AnotherApp from "./another-app/AnotherApp"; // Correct import
import StaticArticleRedirect from './components/articles/StaticArticleRedirect';
import CompoundInterestApp from './apps/compound/CompoundInterestApp';
import CreditCardDebtApp from './apps/credit-card-debt/CreditCardDebtApp';
import AllowanceTrapApp from './apps/allowance-trap/AllowanceTrapApp';
import MortgageCalculatorApp from './apps/mortgage/MortgageCalculatorApp';
import MortgageOverpaymentCalculatorApp from './apps/mortgage/MortgageOverpaymentCalculatorApp';
import EquitySplitCalculatorApp from './apps/equity-split/EquitySplitCalculatorApp';
import BrokePromptGeneratorApp from './apps/broke-prompt-generator/BrokePromptGeneratorApp';
import AppsIndex from './apps/AppsIndex'
import Home from './components/Home'
import { ThemeProviderComponent } from './ThemeContext'; // Import your ThemeProvider
import GoogleAnalytics from './analytics/GoogleAnalytics';
import GAViewTracker from './analytics/GAViewTracker';
import CookieConsent from './components/CookieConsent';
import Privacy from './components/Privacy';
import './App.css';

function App() {
  return (
    <ThemeProviderComponent>
      <Router>
        <GoogleAnalytics />
        <GAViewTracker />
        <CookieConsent />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apps" element={<AppsIndex />} />
          <Route path="/apps/budget-calculator" element={<BudgetApp />} />
          <Route path="/apps/compound-interest-calculator" element={<CompoundInterestApp />} />
          <Route path="/apps/credit-card-compound-debt" element={<CreditCardDebtApp />} />
          <Route path="/apps/property-buyout-calculator" element={<EquitySplitCalculatorApp />} />
          <Route path="/apps/100k-125k-personal-allowance-tax-trap" element={<AllowanceTrapApp />} />
          <Route path="/apps/mortgage-calculator" element={<MortgageCalculatorApp />} />
          <Route path="/apps/mortgage-overpayment-calculator" element={<MortgageOverpaymentCalculatorApp />} />
          <Route path="/apps/i-earn-ok-money-but-still-feel-broke" element={<BrokePromptGeneratorApp />} />
          <Route path="/apps/another" element={<AnotherApp />} />
          {/* Serve static pre-rendered articles from /public/articles */}
          <Route path="/articles" element={<StaticArticleRedirect />} />
          <Route path="/articles/:slug" element={<StaticArticleRedirect detail />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProviderComponent>
  );
}

export default App;
